module.exports = __webpack_public_path__ + "img/mini.3b6def20.svg";